import { Icon } from '../../ui/Icon'
import { Modal } from '../../ui/Modal'
import type { Order, OrderStatus } from './api'
import { STATUS_TONE, nextSteps, statusText } from './model'

export interface StatusDialogProps {
  order: Order
  onPick: (status: OrderStatus, cashCollected: boolean) => void
  onClose: () => void
}

/**
 * Перевод статуса кнопкой — запасной путь к перетаскиванию: на сенсорном
 * экране карточку не потянешь, да и осознанный выбор из списка иногда нужнее.
 */
export function StatusDialog({ order, onPick, onClose }: StatusDialogProps) {
  const steps = nextSteps(order)

  return (
    <Modal title={`Заказ № ${order.number}`} onClose={onClose}>
      <p className="ord-now">
        Текущий статус
        <span className="ui-status" data-tone={STATUS_TONE[order.status]}>
          {statusText(order.status)}
        </span>
      </p>
      {steps.length === 0 ? (
        <p className="ui-muted-line">Заказ завершён — дальше переводить некуда.</p>
      ) : (
        <div className="ord-choices">
          {steps.map((step) => (
            <button
              key={step.label}
              type="button"
              className="ui-btn ord-choice"
              data-variant="secondary"
              onClick={() => {
                onPick(step.to, step.cash ?? false)
              }}
            >
              <span className="ui-status" data-tone={STATUS_TONE[step.to]}>
                {step.label}
              </span>
              <Icon name="i-back" className="go" />
            </button>
          ))}
        </div>
      )}
      <div className="mfoot">
        <button type="button" className="ui-btn" data-variant="secondary" onClick={onClose}>
          Закрыть
        </button>
      </div>
    </Modal>
  )
}
